import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const runZero = defineConnector({
  identifier: "runZero",
  name: "runZero",
  tagLine: "Network discovery and asset inventory",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://console\\.runzero\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the runZero console, navigate to **Account › API Keys** and create a new organization API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "runZero API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://console.runzero.com/api/v1.0/org/key",
  },
});
